import { Controller } from "@hotwired/stimulus";

// GO4TEACH workshop (lot 9): the rows' checkboxes, « Tout sélectionner », and the bulk bar —
// shown with its count as soon as one document is selected, hidden when none is.
export default class extends Controller {
  static targets = ["item", "all", "bar", "count"];
  static values = { one: String, other: String };

  connect() {
    this.refresh();
  }

  toggleAll() {
    this.itemTargets.forEach((item) => { item.checked = this.allTarget.checked; });
    this.refresh();
  }

  clear() {
    this.itemTargets.forEach((item) => { item.checked = false; });
    if (this.hasAllTarget) this.allTarget.checked = false;
    this.refresh();
  }

  refresh() {
    const count = this.itemTargets.filter((item) => item.checked).length;
    if (this.hasAllTarget) {
      this.allTarget.checked = count > 0 && count === this.itemTargets.length;
      this.allTarget.indeterminate = count > 0 && count < this.itemTargets.length;
    }
    if (this.hasBarTarget) this.barTarget.hidden = count === 0;
    if (this.hasCountTarget) {
      this.countTarget.textContent = (count === 1 ? this.oneValue : this.otherValue).replace("%{count}", count);
    }
    this.itemTargets.forEach((item) => {
      item.closest("[data-g4t-row]")?.classList.toggle("is-selected", item.checked);
    });
  }
}
